export namespace IDocument {
  export enum Source {
    SOURCE_UNKNOWN = 'SOURCE_UNKNOWN',
    NO_SOURCE_PROVIDED = 'NO_SOURCE_PROVIDED',
    BRAND_IDV = 'BRAND_IDV',
    PURCHASE_ORDER = 'PURCHASE_ORDER',
    PURCHASE_ORDER_TEST_DATA = 'PURCHASE_ORDER_TEST_DATA',
  }

  /**
   * Return an instance of IDocument with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IDocument>): IDocument =>
    ({
      ...(partial ?? {}),
    }) as IDocument;
}

export interface IDocument {
  token: string | undefined;
  url: string | undefined;
  file_name: string | undefined;
  /**
   * @protobufOption (faire.protobuf.validation) = TIMESTAMP_MILLIS
   */
  created_at: number | undefined;
}
